<template>
  <div class="QuestionListModal">
    <el-dialog
        title="选择题目"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <el-form :inline="true" :model="filter" size="small" ref="form">
        <el-form-item label="试题类型">
          <el-select
              style="width: 150px"
              v-model="filter.type"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in questionType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目标签:">
          <AppTreeSelect
              style="width: 150px"
              :options="tagData"
              :valueArr="filter.tagIds"
              @tagChange="tagChange"
          ></AppTreeSelect>
        </el-form-item>
        <el-form-item>
          <el-input
              v-model="filter.keyword"
              placeholder="试题名称"
              @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查找</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <XTable ref="table"
              :api="getCanAddTestQuestionList"
              :state="canAddTestQuestionList"
              :columns="columns"
              :loading="canAddTestQuestionListLoading"
              :tableSize="tableSize"
              :firstColumn="firstColumn"
              :layout="layout"
              :max-height="400"
              :row-key="rowKey"
              @selection-change="handleSelectionChange"
      ></XTable>
      <div style="text-align: center">
        <el-button type="primary" @click="selectConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {QUESTION_TYPE, SUBJECT_TYPE} from "@/utils/constants";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";
import XTable from "@/components/XTable/index.vue";

export default {
  name: "QuestionListModal",
  components: {XTable, AppTreeSelect},
  data() {
    const questionType = Object.keys(QUESTION_TYPE).map((key) => {
      return {
        id: key,
        name: SUBJECT_TYPE[key],
      };
    });
    return {
      tableSize: "small",
      firstColumn: false,
      layout: "sizes, prev, pager, next",
      tagData: [],
      selectRow: [],
      visible: false,
      rules: {},
      questionType: [...questionType],
    };
  },
  watch: {},
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
    ...mapState("pluginCenter", ["canAddTestQuestionList", "canAddTestQuestionListLoading"]),
    filter: {
      get() {
        return this.$store.state.pluginCenter.canAddTestQuestionListFilter;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "canAddTestQuestionListFilter",
          value,
        });
      },
    },
    columns() {
      const self = this;
      const columns = [
        {
          type: "selection",
          width: 50,
          reserveSelection: true
        },
        {
          prop: "id",
          label: "ID",
          width: 100,
        },
        {
          prop: "name",
          label: "试卷名称",
        },
      ]
      return columns;
    }
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.tagData = this.tagCategoryList.data;
  },
  methods: {
    ...mapActions("courseCenter", ["getTagCategoryList"]),
    ...mapActions("pluginCenter", ["getCanAddTestQuestionList"]),
    openQuestionSelectList(testPaperId) {
      this.visible = true;
      this.filter.testPaperId = testPaperId;
      this.getCanAddTestQuestionList({})
    },
    selectConfirm() {
      this.$emit("selectConfirm", this.selectRow)
      this.$refs.table.$refs.xTable.$refs.appTable.clearSelection();
      this.visible = false;
    },
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(val) {
      this.selectRow = val;
    },
    onSubmit() {
      this.loadQuestionList();
    },
    onReset() {
      this.filter.tagIds = [];
      this.filter.type = null;
      this.filter.keyword = null;
    },
    tagChange(val) {
      this.filter.tagIds = val;
      this.loadQuestionList();
    },
    loadQuestionList() {
      this.getCanAddTestQuestionList({page: 1});
    }
  }
}
</script>

<style lang="scss" scoped>
.QuestionListModal {
  width: 100%;
}
</style>
